import React from 'react';
import { Navigate } from 'react-router-dom';
import { useModuleCatalog } from '../../config/moduleCatalog';

// Redirects a module's bare path (e.g. "/workforce-institutional") to its
// first submodule tab, reading that first key from the live catalog so an
// admin reordering/renaming submodules never leaves this pointed at a
// stale key. Falls back to the given default if the catalog has no
// submodules for the module (shouldn't happen, but keeps routing safe).
export default function ModuleIndexRedirect({ moduleId, fallback }) {
  const { catalog } = useModuleCatalog();
  const firstKey = catalog.find((module) => module.id === moduleId)?.submodules?.[0]?.key ?? fallback;
  return <Navigate to={firstKey} replace />;
}
